( () => {
	const allFilterForms = document.querySelectorAll<HTMLFormElement>( 'form[data-ufr-advanced-filter]' );

	allFilterForms.forEach( ( filterFormElement ) => {

		const listWrapper = filterFormElement.nextElementSibling as HTMLUListElement;
		const listViewRadios = filterFormElement.querySelectorAll<HTMLInputElement>( 'input[name="list-view"]' );
		listViewRadios.forEach( ( listViewRadio ) => {
			listViewRadio?.addEventListener( 'change', () => {
				listWrapper?.setAttribute( 'data-ufr-view', listViewRadio.value );
			} );
		} );

	} );
} )();
